import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '..';
import InternalLinkingShape from '@images/backgrounds/internal-linking.svg';
import ArrowRight from '@images/icons/arrow-right.svg';
import { InternalLinkingProps } from './InternalLinkingProps';

import * as styles from './InternalLinking.module.scss';

export const InternalLinking: React.FC<InternalLinkingProps> = ({
	links,
	className,
	title = 'Do you need more information?',
}) => {
	return (
		<PaddingContainer className={className}>
			<WidthContainer>
				<h2 className="font-size-medium-title mb-4">{title}</h2>
				<div className={classNames(styles.wrapper, 'relative')}>
					<div
						className={classNames(
							styles.container,
							'd-flex flex-wrap justify-content-center justify-content-sm-start relative z-9'
						)}
					>
						{links.map((link) => (
							<Link
								key={link.title}
								to={link.link}
								className={classNames(styles.link, 'd-flex flex-column')}
							>
								<div className={styles.icon}>
									<img src={link.icon} alt={link.title + ' icon'} />
								</div>
								<div className={styles.typographies}>
									<h6 className="font-size-md">{link.title}</h6>
									<ul>
										{link.items.map((item) =>
											typeof item === 'string' ? (
												<li key={item} className="font-size-16">
													{item}
												</li>
											) : (
												<li key={item.title} className="font-size-16">
													<span>{item.title}</span>
													<ul className={styles.sublist}>
														{item.subItems.map((subItem) => (
															<li key={subItem}>{subItem}</li>
														))}
													</ul>
												</li>
											)
										)}
									</ul>
								</div>
								<div className={styles.readMore}>
									<span>
										Read more <img className={styles.arrow} src={ArrowRight} />
									</span>
								</div>
							</Link>
						))}
					</div>
					<img
						className={styles.background}
						src={InternalLinkingShape}
						alt="shape"
					/>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
